/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AutogroupsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      groups: this.store.findAll('group'),
      schools: this.store.findAll('school'),
      schoolGroups: this.store.findAll('schools/group'),
      usageSets: this.store.findAll('schools/usage-set'),
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
